import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {

  private defaultCountry = '';

  constructor() {
  }

  getDefaultCountry(): string {
    return this.defaultCountry ?? '';
  }

  setDefaultCountry(defaultCountry: string): void {
    this.defaultCountry = defaultCountry;
  }
}
